import axiosClient from './axiosClient';

const authApi = {
  postAuthRefreshToken(refreshToken) {
    const url = '/api/auth/token';
    const payload = { refreshToken: refreshToken };
    return axiosClient.post(url, payload);
  },
  postAuthSignIn(username, password) {
    const url = '/api/auth/login';
    const payload = { username: username, password: password };
    return axiosClient.post(url, payload);
  },
  postChangePassword(old_password, new_password, token) {
    const url = '/api/auth/changePassword';
    const payload = {
      currentPassword: old_password,
      newPassword: new_password,
    };
    return axiosClient.post(url, payload, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
  getUser(token) {
    const url = '/api/auth/user';
    return axiosClient.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
  postLogout(token){
    const url = '/api/auth/logout';
    return axiosClient.post(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  }
};

export default authApi;
